module.exports = __webpack_public_path__ + "img/comicEntry.2de61182.png";